import { render, staticRenderFns } from "./ModalContentDetails.vue?vue&type=template&id=29df3ef4&"
import script from "./ModalContentDetails.vue?vue&type=script&lang=js&"
export * from "./ModalContentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentDetails.vue?vue&type=style&index=0&id=29df3ef4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports